import { SERVER_URL } from "../constants/constants.js";
import { customFetch } from "../components/common/fetchWrapper";

export const ingestionService = {
  scrape,
  render,
  dispatch_ocr,
  retrieve_ocr,
  getIngestionRunDetail,
  classifyDealJacket,
};

async function scrape(ingestionRequest) {
  let url = SERVER_URL + "/ingestor/scrape";

  const result = await customFetch(
    "POST",
    url,
    null,
    JSON.stringify(ingestionRequest)
  );
  return result;
}

async function render(ingestionRequest) {
  let url = SERVER_URL + "/ingestor/render";
  const result = await customFetch(
    "POST",
    url,
    null,
    JSON.stringify(ingestionRequest)
  );
  return result;
}

async function dispatch_ocr(ingestionRequest) {
  let url = SERVER_URL + "/ingestor/dispatch";
  const result = await customFetch(
    "POST",
    url,
    null,
    JSON.stringify(ingestionRequest)
  );
  return result;
}

async function retrieve_ocr(ingestionRequest) {
  let url = SERVER_URL + "/ingestor/retrieve";
  const result = await customFetch(
    "POST",
    url,
    null,
    JSON.stringify(ingestionRequest)
  );
  return result;
}

async function getIngestionRunDetail(run_id) {
  let url = SERVER_URL + "/ingestor/run/" + run_id;
  const result = await customFetch("GET", url, null, null);
  return result;
}

async function classifyDealJacket(dealjacket_id) {
  let url = SERVER_URL + "/dealjacket/" + dealjacket_id + "/classify";
  const result = await customFetch("POST", url, null, null);
  return result;
}
